import yup from './yup';

const reelReturnSchema = yup.object({
  clientRmaNumber: yup.string().max(80).required(),
  depotId: yup.string().required().nullable(),
  returnByDate: yup.string().required().nullable(),
});

export default reelReturnSchema;
